import React from "react";
import { Navigate, Route, Routes as RouterRoutes } from "react-router";
import {
  TeamPage,
  TeamSignupPage,
  SignupPage,
  SignupTeamDetailsPage,
  BrandPage,
  UserSettingsPage,
  OrdersPage,
  OrderPage,
  ResetPasswordPage,
  ResetPasswordWithTokenPage,
  CartPage,
  CartCompletedPage,
  DesignRemixPage,
  CollectionRemixPage,
  LoginPage,
  InvitationAcceptancePage,
  PurchaseCollectionPage
} from "views/pages";
import EditorContainer from "views/containers/editor";
import SubscriptionsPageContainer from "views/containers/SubscriptionsPageContainer";
import DesignsPage from "views/pages/designsPage";
import UpgradeSuccessPage from "views/pages/upgradeSuccessPage";
import withUser from "views/enhancers/withUser";
import PATHS from "./paths";
import { RouteElement } from "./RouteElement";

import RenderPage from "views/pages/RenderPage/RenderPageLazy";

const routeElement = (Component, path, props = {}) => (
  <RouteElement Component={Component} path={path} {...props} />
);

const UserRoutesContent = () => (
  <RouterRoutes>
    <Route path={PATHS.team} element={routeElement(TeamPage, PATHS.team)} />
    <Route
      path={`${PATHS.designs}/*`}
      element={routeElement(DesignsPage, `${PATHS.designs}/*`)}
    />
    <Route
      path={`${PATHS.brand}/*`}
      element={routeElement(BrandPage, `${PATHS.brand}/*`)}
    />
    <Route
      path={`${PATHS.subscription}/*`}
      element={routeElement(
        SubscriptionsPageContainer,
        `${PATHS.subscription}/*`
      )}
    />
    <Route
      path={PATHS.settings}
      element={routeElement(UserSettingsPage, PATHS.settings)}
    />
    <Route
      path={PATHS.editorDesign}
      element={routeElement(EditorContainer, PATHS.editorDesign)}
    />
    <Route
      path={PATHS.editor}
      element={<Navigate replace to={PATHS.designs} />}
    />
    <Route
      path={PATHS.ordersId}
      element={routeElement(OrderPage, PATHS.ordersId)}
    />
    <Route
      path={PATHS.orders}
      element={routeElement(OrdersPage, PATHS.orders)}
    />
    <Route
      path={PATHS.cartComplete}
      element={routeElement(CartCompletedPage, PATHS.cartComplete)}
    />
    <Route path={PATHS.cart} element={routeElement(CartPage, PATHS.cart)} />
    <Route
      path={PATHS.remix}
      element={routeElement(DesignRemixPage, PATHS.remix)}
    />
    <Route
      path={PATHS.remixCollection}
      element={routeElement(CollectionRemixPage, PATHS.remixCollection)}
    />
    <Route
      path={PATHS.purchaseCollectionWithCollectionId}
      element={routeElement(
        PurchaseCollectionPage,
        PATHS.purchaseCollectionWithCollectionId
      )}
    />
    <Route path="*" element={<Navigate replace to={PATHS.designs} />} />
  </RouterRoutes>
);

let UserRoutesWithUser;
const UserRoutes = props => {
  UserRoutesWithUser = UserRoutesWithUser || withUser(UserRoutesContent);
  const WrappedUserRoutes = UserRoutesWithUser;

  return <WrappedUserRoutes {...props} />;
};

const Routes = () => (
  <RouterRoutes>
    <Route
      path={PATHS.signup}
      element={routeElement(SignupPage, PATHS.signup)}
    />
    <Route
      path={PATHS.signupTeam}
      element={routeElement(TeamSignupPage, PATHS.signupTeam)}
    />
    <Route
      path={PATHS.signupTeams}
      element={routeElement(TeamSignupPage, PATHS.signupTeams)}
    />
    <Route
      path={PATHS.signupTeamDetails}
      element={routeElement(SignupTeamDetailsPage, PATHS.signupTeamDetails)}
    />
    <Route
      path={PATHS.signupWithToken}
      element={routeElement(SignupPage, PATHS.signupWithToken)}
    />
    <Route path={PATHS.login} element={routeElement(LoginPage, PATHS.login)} />
    <Route
      path={PATHS.invitationsWithToken}
      element={routeElement(
        InvitationAcceptancePage,
        PATHS.invitationsWithToken
      )}
    />
    <Route
      path={PATHS.resetPasswordWithToken}
      element={routeElement(
        ResetPasswordWithTokenPage,
        PATHS.resetPasswordWithToken
      )}
    />
    <Route
      path={PATHS.resetPassword}
      element={routeElement(ResetPasswordPage, PATHS.resetPassword)}
    />
    <Route
      path={PATHS.subscriptionSuccess}
      element={routeElement(UpgradeSuccessPage, PATHS.subscriptionSuccess)}
    />
    <Route
      path={PATHS.rendererInject}
      element={routeElement(RenderPage, PATHS.rendererInject)}
    />
    <Route
      path={PATHS.renderer}
      element={routeElement(RenderPage, PATHS.renderer)}
    />
    <Route path="*" element={<UserRoutes />} />
  </RouterRoutes>
);

export default Routes;
